import axios from "./axios"; // Import the centralized Axios instance

const state = {
  settings: [],
};

const getters = {
  allSettings: (state) => state.settings,
};

const actions = {
  async fetchSettings({ commit }) {
    try {
      commit("resetSettings");
      const response = await axios.get("/setting", { params: { page: 1, limit: 25 } });
      commit("setSettings", response.data);
      return response.data;
    } catch (error) {
      console.error("Failed to fetch settings:", error);
    }
  },
  async createSetting({ commit }, setting) {
    try {
      const response = await axios.post("/setting", setting);
      commit("addSetting", response.data);
      return response.data;
    } catch (error) {
      console.error("Failed to create setting:", error);
      throw error;
    }
  },
  async fetchSettingById(_, id) {
    try {
      const response = await axios.get(`/setting/${id}`);
      return response.data;
    } catch (error) {
      console.error("Failed to fetch setting:", error);
      throw error;
    }
  },
  async updateSetting({ commit }, setting) {
    try {
      const response = await axios.put(`/setting/${setting.id}`, setting);
      commit("updateSetting", response.data);
    } catch (error) {
      console.error("Failed to update setting:", error);
      throw error;
    }
  },
  async deleteSettingById({ commit }, id) {
    try {
      const response = await axios.delete(`/setting/${id}`);
      commit("removeSetting", id);
      return response.data;
    } catch (error) {
      console.error("Failed to delete setting:", error);
      throw error;
    }
  },
};

const mutations = {
  setSettings(state, settings) {
    state.settings = settings.data; // Ensure this matches your API's response structure
  },
  addSetting(state, setting) {
    state.settings.push(setting);
  },
  updateSetting(state, updatedSetting) {
    const index = state.settings.findIndex(
      (setting) => setting.id === updatedSetting.id
    );
    if (index !== -1) {
      state.settings.splice(index, 1, updatedSetting);
    }
  },
  removeSetting(state, id) {
    state.settings = state.settings.filter(
      (setting) => setting.id !== id
    );
  },
  resetSettings(state) {
    state.settings = [];
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
